<template>
  <div id="app">
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view> -->

    <keep-alive :include="catch_components">
      <router-view></router-view>
    </keep-alive>
    <!-- <router-view /> -->
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      // catch_components: [],
    };
  },
  computed: {
    catch_components() {
      return this.$store.getters.getCOMPONENTS;
    },
  },
  methods: {
  },
  created() {
    // console.log(this.$store.getters.getCOMPONENTS, "8fffffff9");
    // this.catch_components = this.$store.getters.getCOMPONENTS;
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 0;
  margin: 0;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue